export default __webpack_public_path__ + "static/media/node.abfaef34.png";